import { z } from 'zod';

export const stockTrialPreviewSchema = z.object({
  capturedAt: z.string().datetime(),
  destinations: z.array(
    z.object({
      variantId: z.string(),
      sku: z.string().nullable(),
      onlineStock: z.number().int(),
      channel: z.enum(['TIENDANUBE', 'MERCADOLIBRE']),
      connectionId: z.string(),
      accountName: z.string(),
      externalAccountId: z.string(),
      listingId: z.string().nullable(),
      externalListingId: z.string().nullable(),
      externalVariantId: z.string().nullable(),
      observedStock: z.number().int().nullable(),
      observedAt: z.string().datetime().nullable(),
      proposedStock: z.number().int().nonnegative().nullable(),
      status: z.enum(['WOULD_PUBLISH', 'BLOCKED', 'EXCLUDED', 'NOT_LINKED']),
      reason: z.string().nullable(),
    }),
  ),
});
export type StockTrialPreview = z.infer<typeof stockTrialPreviewSchema>;

export const stockTrialQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export const stockTrialHistorySchema = z.object({
  state: z.enum(['SETUP', 'READ_ONLY', 'TRIAL', 'ACTIVE']),
  startedAt: z.string().datetime().nullable(),
  page: z.number().int(),
  pageSize: z.number().int(),
  total: z.number().int(),
  data: z.array(
    z.object({
      id: z.string().uuid(),
      createdAt: z.string().datetime(),
      sku: z.string().nullable(),
      status: z.string(),
      lastError: z.string().nullable(),
      preview: stockTrialPreviewSchema.nullable(),
      movement: z
        .object({
          id: z.string().uuid(),
          type: z.string(),
          channel: z.enum(['TIENDANUBE', 'MERCADOLIBRE']).nullable(),
          reference: z.string().nullable(),
          previousStock: z.number().int(),
          delta: z.number().int(),
          resultingStock: z.number().int(),
        })
        .nullable(),
    }),
  ),
});
export type StockTrialHistory = z.infer<typeof stockTrialHistorySchema>;
